import { z } from "zod";
import { VALIDATION_MESSAGES_CARD, addressRegex } from "constants/validations";

// Address Schema
export const addressSchema = z
    .string()
    .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
    .max(30, { message: "Maximum 30 characters" })
    .regex(addressRegex, { message: "Invalid characters in address" });

export const optionalAddressSchema = z.union([z.literal(""), addressSchema]).optional();
